import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { AccordionFamilyCoexistence as AccordionFamilyCoexistenceVM } from 'shell/view-models/accordion-family-coexistence';
import { FormikErrors, FormikTouched } from 'formik';

interface FamilyCoexistenceProps {
  disabled?: boolean;
  isCohabitation?: boolean;
  values?: AccordionFamilyCoexistenceVM;
  errors?: FormikErrors<AccordionFamilyCoexistenceVM>;
  touched?: FormikTouched<AccordionFamilyCoexistenceVM>;
  onChange: (
    key: keyof AccordionFamilyCoexistenceVM,
    value: AccordionFamilyCoexistenceVM[keyof AccordionFamilyCoexistenceVM]
  ) => void;
  resetForm: () => void;
}

const FamilyCoexistenceFormComponent = ({
  values,
  onChange,
  isCohabitation,
}: FamilyCoexistenceProps): React.ReactElement => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Identificativo comune"
          aria-label="Identificativo comune"
          id="municipality-identifier"
          fullWidth
          onChange={(event) => {
            onChange('municipalityIdentifier', event?.target.value);
          }}
          value={values?.municipalityIdentifier || ''}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Codice ISTAT"
          aria-label="Codice ISTAT"
          id="istat-code"
          fullWidth
          onChange={(event) => {
            onChange('codeIstat', event?.target.value);
          }}
          value={values?.codeIstat || ''}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Identificativo ANPR"
          aria-label="Identificativo ANPR"
          id="identifier-anpr"
          fullWidth
          onChange={(event) => {
            onChange('identifierAnpr', event?.target.value);
          }}
          value={values?.identifierAnpr || ''}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data origine"
          value={values?.originDate || null}
          disabled
          onChange={(value) => {
            onChange('originDate', value || null);
          }}
          renderInput={(params) => (
            <PmiTextField {...params} id="originDate" fullWidth error={false} helperText="" />
          )}
        />
      </Grid>
      {isCohabitation ? (
        <Grid
          container
          item
          spacing={0}
          rowSpacing={{ xs: 1, md: 0 }}
          columnSpacing={{ xs: 0, md: 1 }}
          xs={12}
        >
          <Grid item xs={12} md={4}>
            <PmiTextField
              label="Specie convivenza"
              aria-label="Specie convivenza"
              id="special-cohabitation"
              fullWidth
              onChange={(event) => {
                onChange('especiallyCoexistenceDescription', event?.target.value);
              }}
              value={values?.especiallyCoexistenceDescription || ''}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <PmiTextField
              label="Denominazione convivenza"
              aria-label="Denominazione convivenza"
              id="name-coexistence"
              fullWidth
              onChange={(event) => {
                onChange('nameCoexistence', event?.target.value);
              }}
              value={values?.nameCoexistence || ''}
              disabled
            />
          </Grid>
        </Grid>
      ) : undefined}
    </Grid>
  );
};

FamilyCoexistenceFormComponent.displayName = 'Family Coexistence Form component';

const FamilyCoexistenceForm = memo(FamilyCoexistenceFormComponent);

export default FamilyCoexistenceForm;
